<template>
    <div class="p-index">
        <div class="p-index--wrap">
            <cmp-home-video :container="containers['home-video']"></cmp-home-video>
            <cmp-home facet="home" :container="containers.home"></cmp-home>
        </div>
    </div>
</template>

<script>
    import routeMixin from 'vue/mixins/route';

    export default {
        mixins: [routeMixin],
    };
</script>



// WEBPACK FOOTER //
// index.vue?fc9f6700